export function getMarkup (totalPayRate, grossProfit) {
  return (grossProfit * 100) / totalPayRate
}
